import React, {useEffect, useState, useContext} from "react";
import "./DynaTable.scss";
import commaSeparator, {formatToPersianAddComma} from "../../utils/CommaSeparator";
import NumericFunction from "../../utils/NumericFunction";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {SetPrintDataContext} from "../../Pages";
import numericFunction from "../../utils/NumericFunction";

const DynaTable = ({
                     column,
                     data,
                     className,
                     mainWidth,
                     onRowClick,
                     priceFields,
                     defaultSelectedRowIdValue,
                     defaultSelectedRowIdName,
                     searchFilterBox,
                     searchFilterBoxStyle,
                     boldText,
                     cellWidth,
                     showFooter
                   }) => {
  const [selectedRow, setSelectedRow] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [optionValue, setOptionValue] = useState("");
  const [myColumn, setMyColumn] = useState([]);
  const [myData, setMyData] = useState([]);
  const [footerData, setFooterData] = useState([]);
  let fieldColumn = [];
  let numberColumn = [];
  let boldColumn = [];
  const navigate = useNavigate();
  const setEdit = useContext(SetPrintDataContext);

  useEffect(() => {
    if (searchValue !== "" && optionValue !== "") {
      const filtered = data.filter((item) => {
        const selectedItem = item[optionValue];
        return selectedItem.toLowerCase().includes(searchValue.toLowerCase());
      });
      setMyColumn([...column]);
      setMyData([...filtered]);
    } else {
      setMyColumn([...column]);
      setMyData([...data]);
    }
  }, [searchValue, optionValue, data]);

  useEffect(() => {
    if (
      defaultSelectedRowIdValue !== undefined &&
      defaultSelectedRowIdName !== undefined
    ) {
      const filtered = data.filter((item) => {
        const selectedItem = item[defaultSelectedRowIdName];
        return selectedItem
          .toLowerCase()
          .includes(defaultSelectedRowIdValue.toLowerCase());
      });
      setSelectedRow(filtered[0]);
    }
  }, [defaultSelectedRowIdValue, defaultSelectedRowIdName]);

  useEffect(() => {
    if (priceFields !== undefined && showFooter) {
      let temp = []
      column.forEach((q) => {
        let flag = 0
        let obj = {}

        if (priceFields.includes(q.field)) {
          data.forEach((d) => {
            flag = flag + +d[q.field]
          })
          obj = {field: q.field, title: flag, headerFilter: true}
          temp.push(obj)
        } else {
          obj = {field: q.field, title: "", headerFilter: true}
          temp.push(obj)
        }
      })
      setFooterData(temp)
    }
  }, [])

  if (priceFields !== undefined) {
    numberColumn = [...priceFields];
  }

  if (boldText !== undefined) {
    boldColumn = [...boldText];
  }

  myColumn.forEach((myColumn) => {
    if (myColumn.headerFilter) {
      fieldColumn.push(myColumn.field);
    }
  });
  const exception = ["/sellFactor", "/saleReturn", "/buyReturn"];

  function editHandler(address, mainid) {
    let adresArray = address.split("/");
    let addressId = adresArray[adresArray.length - 1];
    // /sellFactor || /storeRemittance || /opration/1-m
    // اینجا یه استثنا داریم و اون اینه که  اگه قرار بود فاکتور خرید سابق بره باید با کانتکس دیتا رو پاس بدم بهش
    if (address === "/Operation/1-m") {
      axios({
        method: "GET",
        url: `${localStorage.getItem("apiUrl")}/get-form/`,
        params: {
          pkValue: mainid,
          id: "326-s",
          state: "edit",
        },
        headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
      }).then((response) => {
        setEdit(response.data);
        navigate("/Operation/1-m");
      });
    } else {
      if (exception.includes(address)) {
        navigate(address, {
          state: {mode: "edit", id: mainid, manualDocumentId: mainid},
        });
      } else {
        navigate(address, {
          state: {mode: "edit", primaryKey: mainid, id: addressId},
        });
      }
    }
  }

  try {
    return (
      <>
        {searchFilterBox && (
          <div
            className={`${
              searchFilterBoxStyle !== undefined ? searchFilterBoxStyle : ""
            }`}
          >
            <div className="select-box-filter">
              <select
                value={optionValue}
                onChange={(event) => {
                  setOptionValue(event.target.value);
                }}
              >
                <option value="" selected disabled hidden>
                  انتخاب کنید ...
                </option>
                {column?.map((v, index) => (
                  <>
                    {v.headerFilter && (
                      <option key={"O" + index} value={v.field}>
                        {v.title}
                      </option>
                    )}
                  </>
                ))}
              </select>
            </div>

            <input
              type="text"
              value={NumericFunction.e2p(searchValue)}
              onChange={(event) => {
                setSearchValue(NumericFunction.p2e(event.target.value));
              }}
            />
          </div>
        )}

        <ul
          className={`DynaTable ${className !== undefined ? className : ""}`}
          style={{width: mainWidth}}
        >
          <li className="header-table">
            {myColumn?.map((v, index) => (
              <>
                {v.headerFilter && (
                  <span key={"R" + index} className={"table-cell"}>
                  {v.title}
                </span>
                )}
              </>
            ))}
          </li>

          {myData.map((singleRowData, index) => (
            <li
              id={singleRowData.id}
              className={`middle-table ${
                JSON.stringify(singleRowData) === JSON.stringify(selectedRow)
                  ? "select-color"
                  : ""
              }`}
              onClick={() => {
                setSelectedRow(singleRowData);
                onRowClick(singleRowData);
              }}
              key={"R" + index}
            >
              {fieldColumn.map((field, indexField: number) => {
                return (
                  <span key={indexField} className={"table-cell"}
                        style={{
                          fontWeight: `${boldColumn.includes(field) ? "500" : "400"}`,
                          width: `${cellWidth !== undefined && cellWidth}`
                        }}>
                  {field === "edit" && singleRowData["edit"] !== "" ? (
                    <i
                      className="fa fa-edit"
                      onClick={() =>
                        editHandler(
                          singleRowData[field],
                          singleRowData["mainId"]
                        )
                      }
                    ></i>
                  ) : numberColumn.includes(field) ? (
                    formatToPersianAddComma(singleRowData[field])
                  ) : (
                    NumericFunction.e2p(singleRowData[field])
                  )}
                </span>
                );
              })}
            </li>
          ))}

          {showFooter &&
            <li className="header-table footer-table">
              {footerData?.map((v, index) => (
                <>
                  {v.headerFilter && (
                    <span key={"R" + index} className={"table-cell"}>
                  {v.title !== "" ? numericFunction.e2p(commaSeparator(v.title)) : ""}
                </span>
                  )}
                </>
              ))}
            </li>
          }
        </ul>
      </>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }

};
export default DynaTable;
